import { ApiResponse } from 'apisauce';
import { IAccnt, IAccntSnapshot, IVm, IVmSnapshot } from 'src/models';

import { Api } from '../api/api';
import { getGeneralApiProblem } from '../api/api-problem';

import {
  TDeleteAccVmIpResult,
  TGetAccntResult,
  TGetVmResult,
  TSaveAccntResult,
  TSaveVmResult,
} from './AccVmIpTypes';

/**
 * # AccVmIp Api 서비스
 *
 * 서비스의 설명을 작성하세요.
 *
 * ## 사용방법
 *
 * ```ts
 * const service = new AccVmIpApi();
 *
 * ```
 */
export class AccVmIpApi {
  getIncident() {
    throw new Error('Method not implemented.');
  }
  private api: Api;

  constructor(api: Api) {
    this.api = api;
  }

  async getAccnt(options?: { useYn?: 'Y' | 'N' }): Promise<TGetAccntResult> {
    try {
      const url = '/accntInfo';
      const params = options ?? {};
      const response: ApiResponse<any> = await this.api.apisauce.get(url, params);

      if (!response.ok) {
        const problem = getGeneralApiProblem(response);
        if (problem) return problem;
      }

      const accnt: IAccnt[] = response.data.data;
      const responseInfo = response.data;

      return { kind: 'ok', accnt, responseInfo };
    } catch (e) {
      return { kind: 'bad-data' };
    }
  }
  async saveAccnt(newAccnt: IAccntSnapshot): Promise<TSaveAccntResult> {
    try {
      const hasSid = !!newAccnt.accntSid;
      const url = hasSid ? `/accntInfo/${newAccnt.accntSid}` : '/accntInfo';
      const method = hasSid ? this.api.apisauce.put : this.api.apisauce.post;
      const response: ApiResponse<any> = await method(url, newAccnt);

      if (!response.ok) {
        const problem = getGeneralApiProblem(response);
        if (problem) return problem;
      }

      const accnt: IAccnt = response.data.data;
      const responseInfo = response.data;
      return { kind: 'ok', accnt, responseInfo };
    } catch (e) {
      return { kind: 'bad-data' };
    }
  }
  async deleteAccnt(accntSid: number): Promise<TDeleteAccVmIpResult> {
    try {
      const url = `/accnt/${accntSid}`;
      const response: ApiResponse<any> = await this.api.apisauce.delete(url);

      if (!response.ok) {
        const problem = getGeneralApiProblem(response);
        if (problem) return problem;
      }

      const responseInfo = response.data;
      return { kind: 'ok', responseInfo };
    } catch (e) {
      return { kind: 'bad-data' };
    }
  }

  async getVm(options?: { useYn?: 'Y' | 'N' }): Promise<TGetVmResult> {
    try {
      const url = '/vmHist';
      const params = options ?? {};
      const response: ApiResponse<any> = await this.api.apisauce.get(url, params);

      if (!response.ok) {
        const problem = getGeneralApiProblem(response);
        if (problem) return problem;
      }

      const vm: IVm[] = response.data.data;
      const responseInfo = response.data;
      return { kind: 'ok', vm, responseInfo };
    } catch (e) {
      return { kind: 'bad-data' };
    }
  }
  async saveVm(newVm: IVmSnapshot): Promise<TSaveVmResult> {
    try {
      const hasSid = !!newVm.vmSid;
      const url = hasSid ? `/vmHist/${newVm.vmSid}` : '/vmHist';
      const method = hasSid ? this.api.apisauce.put : this.api.apisauce.post;
      const response: ApiResponse<any> = await method(url, newVm);

      if (!response.ok) {
        const problem = getGeneralApiProblem(response);
        if (problem) return problem;
      }

      const vm: IVm = response.data.data;
      const responseInfo = response.data;
      return { kind: 'ok', vm, responseInfo };
    } catch (e) {
      return { kind: 'bad-data' };
    }
  }
  async deleteVm(vmSid: number): Promise<TDeleteAccVmIpResult> {
    try {
      const url = `/vmHist/${vmSid}`;
      const response: ApiResponse<any> = await this.api.apisauce.delete(url);

      if (!response.ok) {
        const problem = getGeneralApiProblem(response);
        if (problem) return problem;
      }

      const responseInfo = response.data;
      return { kind: 'ok', responseInfo };
    } catch (e) {
      return { kind: 'bad-data' };
    }
  }
}
